import { noop } from 'lodash';
import { memo } from 'react';

import { ChevronsLeftIcon } from '@air/design-icons';

import { usePublicWorkspace } from '~/components/PublicWorkspaceProvider';
import { usePublicCustomColors } from '~/hooks/usePublicCustomColors';

export type PublicBoardWorkspaceNavigationProps = {
  onWorkspaceNavigate: () => void;
};

export const PublicWorkspaceNavigation = memo(({ onWorkspaceNavigate = noop }: PublicBoardWorkspaceNavigationProps) => {
  const { workspaceName } = usePublicWorkspace();
  const { headerForegroundColor } = usePublicCustomColors();

  return (
    <div className="flex items-center" data-testid="PUBLIC_WORKSPACE_NAVIGATION">
      <button
        className="flex cursor-pointer items-center border-none bg-transparent p-0 font-medium ads:text-secondary text-16 text-gray-10 hover:underline"
        data-testid="PUBLIC_WORKSPACE_NAVIGATION_BUTTON"
        onClick={onWorkspaceNavigate}
        style={headerForegroundColor ? { color: headerForegroundColor } : undefined}
        type="button"
      >
        <ChevronsLeftIcon size="sm" className="mr-2 inline-block" />
        <div className="truncate text-16 text-inherit">View in&nbsp;{workspaceName}</div>
      </button>
    </div>
  );
});

PublicWorkspaceNavigation.displayName = 'PublicWorkspaceNavigation';
